import { Navigate, type RouteObject } from 'react-router-dom';

import { CVAnalysisResultLayout } from './CVAnalysisResultLayout';
import { CVAnalysisRootLayout } from './CVAnalysisRootLayout';
import { NewCVAnalysisLayout } from './NewCVAnalysisLayout';

export const CvRoutes: RouteObject = {
  path: 'cv',
  element: <CVAnalysisRootLayout />,
  children: [
    { index: true, element: <Navigate to="new" replace /> },
    {
      path: 'new',
      element: <NewCVAnalysisLayout />,
      children: [
        {
          index: true,
          lazy: () => import('../../app/cv/new/cvAnalysis'),
        },
      ],
    },
    {
      path: 'result',
      element: <CVAnalysisResultLayout />,
      children: [
        {
          path: ':cvId',
          lazy: () => import('../../app/cv/result/cvAnalysisResult'),
        },
      ],
    },
    {
      path: 'share',
      lazy: () => import('../../app/cv/share/cvAnalysisShare'),
    },
  ],
};
